<div class="h-100 main-bc" style="overflow: hidden;">
    <router-outlet></router-outlet>
</div>
